import React from 'react';
import MenuItems from '@app/components/header-navigations';
import {
  BackgroundContainer,
  Container,
  HeaderContainer,
} from './header-components';

export default function Header() {
  return (
    <>
      <BackgroundContainer>
        <Container>
          <HeaderContainer>
            <MenuItems />
          </HeaderContainer>
        </Container>
      </BackgroundContainer>
    </>
  );
}
